import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Button from "./Button";

const NextButtonStep = ({
  loading = false,
  disabled = false,
  fullWidth = false,
  onNextStep,
  color = "secondary",
  children,
  sx = {},
}) => {
  return (
    <Button
      disabled={disabled}
      loading={loading}
      fullWidth={fullWidth}
      sx={{
        ...sx,
      }}
      onClick={onNextStep}
      color={color}
      endIcon={<ArrowForwardIcon sx={{ color: "white !important" }} />}
    >
      {children}
    </Button>
  );
};

export default NextButtonStep;
